<template lang="pug">
  .journal-filters
    el-select.journal-filters__element(
      :value="currentYear"
      filterable
      placeholder="Выберите год"
      :disabled="isLoad"
      @change="$emit('update:current-year', $event)"
    )
      el-option(
        v-for="(year, idx) in periodsYears"
        :key="`period-year-${idx}`"
        :label="year"
        :value="year"
      )

    el-select.journal-filters__element(
      :value="currentSemester"
      filterable
      placeholder="Выберите семестер"
      :disabled="isLoad"
      @change="$emit('update:current-semester', $event)"
    )
      el-option(
        v-for="({ semester, periodId }, idx) in periodsByYear"
        :key="`period-${idx}`"
        :label="semester"
        :value="periodId"
      )

    GroupSelect.journal-filters__element(
      :value="currentGroup"
      :groups="groups"
      :hidden-groups="hiddenGroups"
      :disabled="isLoad"
      @input="$emit('update:current-group', $event)"
      @update:hidden-groups="$emit('update:hidden-groups', $event)"
    )

    i.fas.fa-link(aria-hidden="true")

    el-select.journal-filters__element(
      :value="currentDiscipline"
      :disabled="isLoad || !currentGroup"
      placeholder="Выберите дисциплину"
      @change="$emit('update:current-discipline', $event)"
    )
      el-option(
        v-for="(discipline, idx) in disciplines"
        :key="`discipline-${idx}`"
        :label="discipline.discipline"
        :value="discipline.disciplineId"
      )
</template>

<script>
import GroupSelect from './GroupSelect';

export default {
  components: {
    GroupSelect
  },
  props: {
    currentGroup: {
      type: [String, null],
      default: null
    },
    currentDiscipline: {
      type: [String, null],
      default: null
    },
    currentSemester: {
      type: [String, null],
      default: null
    },
    semesters: {
      type: Array,
      default: () => []
    },
    groups: {
      type: Array,
      default: () => []
    },
    hiddenGroups: {
      type: Array,
      default: () => []
    },
    periodsYears: {
      type: Array,
      default: () => []
    },
    periodsByYear: {
      type: Array,
      default: () => []
    },
    isLoad: {
      type: Boolean,
      default: false,
    },
    disciplines: {
      type: Array,
      default: () => []
    },
    currentYear: {
      type: [String, null],
      default: null
    }
  },

  computed: {
    filterIsReady() {
      return this.currentDiscipline;
    }
  },
}
</script>

<style lang="scss" scoped>
.journal-filters {
  display: flex;
  align-items: center;
  gap: 10px;

  @include breakPoints(md) {
    justify-content: center;
    gap: 20px;
  }

  &__element {
    @include breakPoints(md) {
      width: 100%;
    }

  }

  .el-button+.el-button {
    margin-left: 0;
  }

  @include breakPoints(lg) {
    flex-wrap: wrap;
  }
}
</style>
